// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3hfNK","additionalInfo":"AgreementModal_additionalInfo__KtjN4"};